import { Box, Typography } from "@material-ui/core";
import { styled } from "@mui/material";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { imagesList } from "../../../constants";

const CustomInvestors = styled(Box)(({ theme }) => ({
  textAlign: "center",
  marginTop: "100px",
  ".investors-heading": {
    fontSize: "54px",
    lineHeight: "160%",
    fontWeight: "600",
    //textTransform: "uppercase",
  },
  ".investors-description": {
    fontSize: "34px",
    lineHeight: "160%",
    fontWeight: "500",
  },
  ".investors-images": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "span ": {
      maxWidth: "150px",
      width: "100%",
      img: {
        width: "90%",
      },
    },
  },
  [theme.breakpoints.down("md")]: {
    background: "#FEF8E6",
    borderRadius: "6px",
    padding: "5px",
    marginTop: "24px",
    ".investors-heading": {
      fontSize: "16px",
      lineHeight: "25px",
    },
    ".investors-description": {
      fontSize: "12px",
      lineHeight: "16px",
    },
    ".investors-images": {
      "span ": {
        maxWidth: "108px",
      },
    },
  },
}));

const Investors = () => {
  return (
    <CustomInvestors>
      <Box>
        <Typography variant="h2" className="investors-heading">
          Our investors
        </Typography>
        <Typography className="investors-description">
          Our thesis is backed by the best investors out there
        </Typography>
        <Box className="investors-images">
          <LazyLoadImage
            src={imagesList.aboutUsInvestorStellaris}
            alt="Stelaris"
            effect="opacity"
          />
          <LazyLoadImage
            src={imagesList.aboutUsInvestorAvaana}
            alt="Avaana"
            effect="opacity"
          />
        </Box>
      </Box>
    </CustomInvestors>
  );
};
export default Investors;
